import PropTypes from "prop-types";
import {useSelector, useDispatch} from "react-redux";
import {closeDrawer} from "../../actions/drawerActions";
import CategoryEditorHook from "../qd/categories/CategoryEditorHook";
import {createCategoryTemplateAndCloseDrawer, saveCategoryTemplateAndCloseDrawer} from "../../actions/categoryTemplateActions";
import * as TEMPLATE from "../../constants/templateConstants";
import ArgoAppBarHook from "../common/ArgoAppBarHook";
import {createEditorOrigin, EDITOR_TYPES} from "../../utilities/editorInstanceOwnership";

const CategoryCreateEditDrawer = ({ 
    createMode = false,
    templateKey = "",
    templateId = null,
    templateMode = "",
    setLoadingState,
    filter
}) => {
    const dispatch = useDispatch();
    const versionsFilter = useSelector(state => state.filter[TEMPLATE.FILTER.current.category]);
    const versionsFilterState = useSelector(state => state.filter[TEMPLATE.FILTER.versions.category]);
    const drawerStack = useSelector(state => state.drawerStack)
    const editorInstanceId = useSelector(state => state.categoryEditor.instanceId);

    const handleCloseDrawer = () => {
        dispatch(closeDrawer());
    };

    const onCreateSaveSuccess = () => {
        // Navigation handled by withRouter in parent component
    };

    const save = (categoryTemplate) => {
        const requestOwner = createEditorOrigin(EDITOR_TYPES.CATEGORY, editorInstanceId);
        if (createMode) {
            return dispatch(createCategoryTemplateAndCloseDrawer(
                categoryTemplate,
                filter,
                onCreateSaveSuccess,
                requestOwner
            ));
        }
        return dispatch(saveCategoryTemplateAndCloseDrawer(
            categoryTemplate,
            filter,
            versionsFilter,
            templateMode,
            versionsFilterState,
            requestOwner
        ));
    };

    const handleRequestSave = (categoryTemplate) => {
        if ((typeof setLoadingState === "function") && (templateMode !== "versions")) {
            return setLoadingState(save, categoryTemplate);
        }
        return save(categoryTemplate);
    };

    return (
        <div id="CategoryCreateEditDrawer-container-div" style={{height: "100%"}}>
            <ArgoAppBarHook
                title={drawerStack.displayTitle}
                showMenuIconButton={false}
                noIcon={true}
                isDrawer={true}
                width={categoryCreateEditDrawerProps.width}
            />

            <div style={{height: '64px'}}></div>

            <CategoryEditorHook
                createMode={createMode}
                cancel={handleCloseDrawer}
                save={handleRequestSave}
                templateKey={templateKey}
                templateId={templateId}
                width={categoryCreateEditDrawerProps.width}
                scrollTo="CategoryCreateEditDrawer-container-div"
            />
        </div>
    );
};

CategoryCreateEditDrawer.defaultProps = {
    createMode: false,
    templateKey: "",
    templateId: null,
    templateMode: ""
};

CategoryCreateEditDrawer.propTypes = {
    createMode: PropTypes.bool,
    setLoadingState: PropTypes.func,
    templateKey: PropTypes.string,
    templateId: PropTypes.number,
    templateMode: PropTypes.string,
    filter: PropTypes.object,
    versionsFilter: PropTypes.object
};

const categoryCreateEditDrawerProps = {
    opensecondary: true,
    width: "90%",
    docked: false,
    anchor: "right"
};

export default CategoryCreateEditDrawer;

export {categoryCreateEditDrawerProps};
